<script setup lang="ts">
import { onMounted, ref, useTemplateRef, type HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
import { FieldError, fieldVariants, type FieldVariants } from '.';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    orientation?: FieldVariants['orientation'];
}>();

const field = useTemplateRef('field');
const errors = ref([]);

onMounted(() => {
    field.value?.addEventListener('formie:add-error', (e) => {
        const { message } = e.detail;
        errors.value.push(message);
    });

    field.value?.addEventListener('formie:remove-error', () => {
        errors.value = [];
    });
});
</script>

<template>
    <div
        ref="field"
        role="group"
        data-slot="field"
        :data-orientation="orientation"
        :class="
            cn(
                fieldVariants({ orientation }),
                'fui-field has-[>[data-slot=field-content]]:flex-wrap',
                props.class
            )
        "
    >
        <slot />
        <FieldError
            v-if="errors.length > 0"
            :errors="errors"
            class="basis-full"
        />
    </div>
</template>
